// extracted by mini-css-extract-plugin
export var tosLink = "_aq-0";